export const COCKPIT_NAVIGATION_SECTION_IDS = {
  HOME: 'home',
  SUBSCRIPTION: 'subscription',
  COMMUNICATION: 'communication',
  GAMES: 'games',
} as const;
